import gql from 'graphql-tag';

export namespace UserFragments {
  export const User = gql`
    fragment User on User {
      id
      username
      email
      stripeId
      verified
      createdAt
      updatedAt
      citizenshipExpiresAt
      citizenSince
      citizenshipRemindedAt
      role
      name
      phone
      wallet {
        balance
        transactions {
          __typename
          id
          credits
          date

          ... on Ticket {
            refundedAt
            show {
              id
              showDate
              tourId
              address {
                venue
              }
            }
          }

          ... on Deposit {
            creditsRefunded
            creditsRefundable
            amountInCents
            currency
            receiptUrl
            refunds {
              id
              credits
              amountInCents
              date
            }
          }

          ... on ManualCredit {
            createdBy {
              id
              username
            }
          }

          ... on Order {
            refundedAt
            orderItems {
              id
              variant {
                id
                name
              }
            }

            orderFulfillments {
              id
            }
          }

          ... on MeetAndGreetTicketPurchase {
            type
            refundedAt
            quantity
            total
            ticket {
              id
              quota
              show {
                id
                showDate
                tourId
                address {
                  venue
                }
              }
            }
          }
        }
      }
      score {
        total
      }
      hasPassport
      passports {
        id
        expiresAt
      }
      address {
        city
        administrativeArea
        country {
          id
          name
        }
        name
        postalCode
        firstAddressLine
        secondAddressLine
        phone
      }
      locale
      token
      imageUrl
      orders {
        id
      }
      remarks {
        id
        comment
        createdAt
        author {
          id
          username
        }
      }
      emails {
        id
        email {
          id
          category
          status
          batchId
          createdAt
        }
        events {
          id
          type
          timestamp
        }
      }
      blockedAt
      commentsBlockedAt
      activeSessionCount
      citizenshipSubscription {
        status
        price
        interval
        currentPeriodEnd
        willCancelAt
      }
      comments {
        id
        body
        createdAt
        deletedAt
        chat {
          id
          target {
            __typename
            ... on Blog {
              id
              title
            }
            ... on Show {
              id
              description
              showDate
              address {
                venue
                city
              }
            }
          }
        }
      }
    }
  `;
}
